// 回饋明細的純資料判斷。刻意不 import antd/axios，測試才跑得動
// (慣例同 state.js)。

/**
 * 逐題的答案。
 *
 * SurveyCake 的 detail 是 { title, result: [{subject, sn, answer}] }；
 * Google 沒有 detail，只有一段評論全文，回空陣列讓呼叫端改用 content。
 */
export function answersOf(item) {
  const result = item && item.detail && item.detail.result;
  return Array.isArray(result) ? result.filter((r) => r && r.subject) : [];
}

/** 問卷名稱。同一條 webhook 會收到多份問卷，看不出是哪一份就無從判讀。 */
export function surveyTitle(item) {
  return (item && item.detail && item.detail.title) || null;
}

// 問卷第一題是「您主要想回饋的部分是(擇一填寫)」，答案為「關於住宿體驗」或
// 「關於用餐體驗」—— 同一份問卷底下題組完全不同，不標出來會以為是同一種回饋。
const KIND_MARKER = "主要想回饋";

export function feedbackKind(item) {
  const hit = answersOf(item).find((r) => r.subject.includes(KIND_MARKER));
  if (!hit) return null;
  // 「關於住宿體驗」→「住宿體驗」，前綴對辨識沒有貢獻，只佔標籤寬度
  return String(hit.answer).replace(/^關於/, "") || null;
}

// 預覽行取「夠長的第一個答案」而不是某個寫死的題目代號 —— 題目文字會被改，
// 而「這份回饋想說什麼」總是落在敘述性的答案上。門檻取 12 字：再短的多半是
// 「很棒」「沒有」這類單選式回答，放進清單佔了位置卻不能幫人判斷要不要點開。
export const PREVIEW_MIN = 12;

// 住客寫成句子的痕跡。逗號與句號在問卷答案裡幾乎只會出現在自由填答 ——
// 複選題串接用的是頓號 (、)，聯絡資訊、房號、房型名稱則完全沒有標點。
const PROSE = /[，。！？]/;

/**
 * 這個答案是不是「有話要說」。
 *
 * 同一份問卷裡，「床墊：滿意」與整段客訴用同樣的字級並排，眼睛就沒有落點 ——
 * 而後者才是要人去處理的。
 *
 * 判斷用長度加標點，不用題目關鍵字：題目文字會被改，「住客寫了完整句子」不會。
 * 光看長度會誤判 —— 手機號碼、電子郵件、複選題串起來的選項都很長，卻沒有一句
 * 要人去做什麼的話，加深了只是把視線引到個資上。
 */
export function isSubstantive(answer) {
  const text = String(answer == null ? "" : answer);
  return text.length >= PREVIEW_MIN && PROSE.test(text);
}

export function previewOf(item) {
  const answers = answersOf(item);

  if (!answers.length) {
    // Google 評論：content 就是評論全文
    return ((item && item.content) || "").split("\n")[0] || "";
  }

  const prose = answers.find((r) => isSubstantive(r.answer));
  if (prose) return String(prose.answer);

  // 沒有人寫句子時退而求其次取最長的答案 —— 「關於住宿體驗」那種每筆都一樣的
  // 制式答案放進清單等於沒有資訊
  const longest = answers.reduce(
    (best, r) => (String(r.answer).length > String(best.answer).length ? r : best),
    answers[0]
  );

  return String(longest.answer);
}

/**
 * 評分的顏色。2 分的客訴與 5 分的稱讚在清單裡必須一眼分得開 ——
 * 這是掃讀時唯一的落點。
 */
export function ratingTone(rating) {
  if (rating == null) return "default";
  if (rating <= 2) return "red";
  if (rating === 3) return "orange";
  return "green";
}
